import { get } from '@/services/http';
import { TaxTypeModel } from '@/models/tax_type';
import List from './list';

export class TaxTypeList extends List<TaxTypeModel> {
  public async fetch() {
    const res: any = await get('/tax-types', {});
    const taxTypes = res.data || [];
    this.items = [];
    for (const data of taxTypes) {
      const taxType = new TaxTypeModel();
      taxType.mapData(data);
      this.add(taxType);
    }
  }
}
